import http from 'lib/http';

// 组件共享状态：OSS 上传签名
const oss = {
  accessid: '', // 16 位字符串
  callback: '',
  dir: '', // 上传路径
  expire: 0, // 13 位毫秒数
  host: '', // 阿里云 OSS 地址
  name: '',
  policy: '', // Base64 编码字符串
  random: '',
  signature: '', // 28 位字符串
  userid: ''
};

// 判断 access 是否过期（提前 30 秒过期）
function isAccessExpired() {
  // @ts-ignore
  let timestamp = Date.parse(new Date()) / 1000;
  return oss.expire < timestamp + 30;
}

/**
 * 更新 OSS access
 * @return {Promise}
 */
function updateAccess() {
  return http.get('/api/design/osssign/getsign').then(ret => {
    if (ret && typeof ret.expire === 'string') {
      // 时间差 = 服务器时间 - 本地时间
      // 过期时间 = 本地时间 + 时间差 + OSS超时时间30分钟(1800秒)
      // let timeOffset = new Date().getTime() - new Date(ret.expire);
      // @ts-ignore
      ret.expire = (2 * new Date().getTime() - new Date(ret.expire)) / 1000 + 1800;
    }
    Object.assign(oss, ret);
  });
}
/**
 * 获取阿里云的OSS保存地址
 *
 */
export default function aliossAccess() {
  if (isAccessExpired()) {
    return updateAccess().then(() => {
      return oss;
    });
  } else {
    return Promise.resolve(oss);
  }
}
/**
 * 随机生成文件名所用字符串
 *
 * @param {number} len 长度
 * @returns
 */
export function keygen(name, len) {
  len = len || 128;
  let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  let maxPos = chars.length;
  let fileName = '';
  for (let i = 0; i < len; i++) {
    fileName += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  // return fileName;
  return `${oss.dir}${fileName}.${name.split('.').pop()}`;
}

window.keygen = keygen;
window.aliossAccess = aliossAccess;
